


















































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import WaringMessagePO from "@/store/entities/messageinfo/waringmessagepo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TreeSelect from "@riophae/vue-treeselect";
import Moment from "moment-timezone";
@Component({
  components: { TreeSelect },
})
export default class ViewDetail extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  waringmessagePo: WaringMessagePO = new WaringMessagePO();
  loading: boolean = false;
  created() {}
  cancel() {
    (this.$refs.areaForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.waringmessagePo = Util.extend(
        true,
        {},
        this.$store.state.waringmessage.waringMessageItems
      );
    }
  }
  //组织转换
  getOrganization(val) {
    if (val == "" || val == null) {
      return this.L("Unknown");
    } else {
      let ite = JSON.parse(localStorage.getItem("organizations"));
      let info = ite.filter((p) => {
        return p.id == val;
      });
      return info.length > 0 ? info[0].displayName : this.L("Unknown");
    }
  }
  //区域转换
  getArea(val) {
    if (val == "" || val == null) {
      return this.L("Unknown");
    } else {
      let ite = JSON.parse(localStorage.getItem("areas"));
      let info = ite.filter((p) => {
        return p.id == val;
      });
      return info.length > 0 ? info[0].fullName : this.L("Unknown");
    }
  }
  //id转换
  getItemDetaile(val) {
    if (val == "" || val == null) {
      return this.L("Unknown");
    } else {
      let ite = JSON.parse(localStorage.getItem("itemdetail"));
      let info = ite.filter((p) => {
        return p.id == val;
      });
      return info.length > 0 ? info[0].name : this.L("Unknown");
    }
  }
  //状态转换
  getState(val) {
    if (val == 1) {
      return this.L("Pending");
    } else if (val == 2) {
      return this.L("Processing");
    } else if (val == 3) {
      return this.L("Processed");
    } else {
      this.L("Unknown");
    }
  }
  //时间转换
  getDateTime(val) {
    if (val == "" || val == null) {
      return "";
    } else {
      return Moment(val).format("YYYY-MM-DD HH:mm:ss");
    }
  }
  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
